import Api from '@/services/Api' // axois object created in api.js

export default { // export its register method
  getOrganizationPricePerSessionFen ({ organizationId, categoryCode, sessionLengthMin, baseHrIncomeFen }: {organizationId?: number; categoryCode: number; sessionLengthMin: number; baseHrIncomeFen?: number}) {
    console.log(`organizationService.getOrganizationPricePerSessionFen ...organizationId: ${organizationId}, categoryCode: ${categoryCode}, sessionLengthMin: ${sessionLengthMin}, baseHrIncomeFen: ${baseHrIncomeFen}`)
    return Api().get('organization/price-per-session', { params: { organizationId, lessonPackageCategoryCode: categoryCode, sessionLengthMin, baseHrIncomeFen } })
  }
}
